import { Allegato } from "./attachment";

export interface Gruppo {
	id: number;
    nome : string;
    descrizione : string;
}

export interface Ruolo {
    descrizione : string;
    id : number;
    nome : string;
}

export interface Profilo {
    Gruppi : Gruppo[];
	Ruoli : Ruolo[];
	Funzionalita : Funzionalita[];
    Utente : Utente;
    descrizione : string;
    esito : number;
}

export interface UtenteAnonimo {
    gruppi : Gruppo[];
    ruoli : Ruolo[];
    linguaDefault?: string;
}

export interface Funzionalita {
    id : number;
    nome : string;
    description : string;
}

export class Utente {
	titolo: string;
	nome : string;
	cognome : string;
	email : string;
	telefono : string;
	accountRai?: string;
	utenteRai: boolean;
	dataRegistrazione: Date;
	scadenzaAccountRai?: string;
	idCasaDiscografica: string;
	gruppi : Gruppo[];
	ruoli : Ruolo[];
	allegati : Allegato[]
    idUtente?: string;
    linguaDefault?: string;
    flagGDPR?: number;
    casaDiscografica ?: string;
	status?: string;
	inMailingList: boolean;
	CF?: string;
	dataNascita?: string;
	luogoNascita?: string;
	telefonoAlternativo?: string;
	estero?: boolean;
	indirizzo?: string;
	citta?: string;
	provincia?: string;
	idNazione?: string;
	nazione?: string;
	numeroDocumento?: string;
	idDocumento?: string;
	documento?: string;
	captchaResponse?: string;

	constructor() {
		this.inMailingList = true;
		this.allegati = new Array();
		this.allegati.push(new Allegato("Documento"));
	}
}